import { render, staticRenderFns } from "./doceditor.vue?vue&type=template&id=6e5d4c94&scoped=true&"
import script from "./doceditor.vue?vue&type=script&lang=js&"
export * from "./doceditor.vue?vue&type=script&lang=js&"
import style0 from "./doceditor.vue?vue&type=style&index=0&id=6e5d4c94&scoped=true&lang=css&"
import style1 from "./doceditor.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5d4c94",
  null
  
)

export default component.exports